import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from '../../views/services/authentication/authentication.service';
import { environment } from '../../../environments/environment';
import { IUser } from '../../views/models/user';
import { Observable } from 'rxjs';
import { IScheduledCallsDemos } from './i-scheduledCallsDemos';

@Injectable({
  providedIn: 'root'
})
export class FetchScheduledCallsDemosService {

  constructor(private _authenticationService: AuthenticationService, private _httpClient: HttpClient) { }

  private baseUrl: string = environment.baseUrl;
  private currentUser: IUser;
  private httpOptions: {};

  refreshCredentials() {
    this.currentUser = this._authenticationService.currentUserValue;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.currentUser.token}`
      })
    }
  }

  getScheduledCallsDemos(): Observable<IScheduledCallsDemos> {
    this.refreshCredentials();
    return this._httpClient.get<IScheduledCallsDemos>(`${this.baseUrl}/getscheduledcalldemo?partnerId=` + this.currentUser.partnerinfo[0].id, this.httpOptions);
  }
}
